var WDN = WDN || {};

if (typeof WDN.DailyGift === "undefined") {
  WDN.DailyGift = (function () {
    class DailyGift extends HTMLElement {
      constructor() {
        super();
      }

      onCartUpdate(e) {
        let cartResJSON = e.detail;

        if (cartResJSON.items.length === 0) return this.setAttribute("data-added", false);

        let giftsInCart = cartResJSON.items.filter((item) => {
          return item.id === this.variantID && item.properties["_dailyGift"];
        });

        this.setAttribute("data-added", !!giftsInCart[0]);
      }

      onClick() {
        this.setAttribute("data-loading", "");

        fetch(Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            items: [
              {
                id: this.variantID,
                quantity: 1,
                properties: {
                  _dailyGift: true
                }
              }
            ]
          })
        })
          .then((res) => {
            return res.json();
          })
          .then((resJSON) => {
            this.setAttribute("data-added", true);
            this.removeAttribute("data-loading");
            document.querySelector("wdn-cart").reloadCart();
          })
          .catch((err) => {
            this.removeAttribute("data-loading");
          });
      }

      connectedCallback() {
        this.variantID = parseInt(this.getAttribute("data-variant-id"));

        this.onClickBound = this.onClick.bind(this);
        this.onCartUpdateBound = this.onCartUpdate.bind(this);

        let cartCountdown = this.querySelector("[data-countdown='daily_gift_cart']");
        if (cartCountdown && WDN.CountdownNew) {
          new WDN.CountdownNew({
            id: "daily_gift_cart",
            date: cartCountdown.getAttribute("data-countdown-date"),
            headingCampaignSettings: true
          });
        }

        this.addEventListener("click", this.onClickBound);
        document.body.addEventListener("cart:updated", this.onCartUpdateBound);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.onClickBound);
        document.body.removeEventListener("cart:updated", this.onCartUpdateBound);
      }
    }

    customElements.define("daily-gift", DailyGift);
    return DailyGift;
  })();
}
